import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  Button,
  Checkbox,
} from "antd";

import { ROLES, addEditFormLayout as layout } from "../../../utils";
import { AddEditUserReq, addEditUserProps } from "../../../models";

import styles from "../User.module.scss";

const { TextArea } = Input;

const AddEditForm = ({ isAdd, state, actions }: addEditUserProps) => {
  const { currentUser, currentInsurance, insurances } = state || {};

  const [form] = Form.useForm();
  const [formPassword] = Form.useForm();
  const [isInsuranceCompanyRole, setIsInsuranceCompanyRole] = useState(
    currentUser?.role === ROLES.INSURANCE_COMPANY ? true : false
  );

  useEffect(() => {
    if (isAdd) {
      return;
    }

    form.setFieldsValue({
      username: currentUser?.username,
      email: currentUser?.email,
      name: currentUser?.name,
      phoneNumber: currentUser?.phoneNumber,
      role: currentUser?.role,
      note: currentUser?.note,
    });
  }, []);

  useEffect(() => {
    if (currentUser?.organizationId) {
      actions.getInsuranceById &&
        actions.getInsuranceById(currentUser?.organizationId);
    }
  }, [currentUser]);

  useEffect(() => {
    if (!isInsuranceCompanyRole || insurances.length > 0) return;
    actions.getInsurances();
  }, [isInsuranceCompanyRole]);

  useEffect(() => {
    if (currentInsurance && isInsuranceCompanyRole) {
      form.setFieldsValue({
        organization: {
          label: currentInsurance?.name,
          value: currentInsurance?.id,
        },
      });
    }
  }, [currentInsurance]);

  const onFinish = (values: AddEditUserReq) => {
    if (isAdd) {
      const user: AddEditUserReq = {
        email: values.email,
        username: values.username,
        password: values.password,
        name: values.name,
        phoneNumber: values.phoneNumber,
        role: values.role,
        organizationId: isInsuranceCompanyRole ? values.organization : null,
        notification: values.notification,
        note: values.note,
      };

      actions.registerUser && actions.registerUser(user);
      return;
    }

    if (!currentUser) return;
    const updateUser: AddEditUserReq = {
      email: values.email,
      username: values.username,
      name: values.name,
      phoneNumber: values.phoneNumber,
      role: values.role,
      organizationId: isInsuranceCompanyRole
        ? values.organization?.value
          ? values.organization?.value
          : values.organization
        : null,
      note: values.note,
    };

    actions.updateUser && actions.updateUser(updateUser, currentUser.id);
  };

  const onRoleChange = (val: any) => {
    setIsInsuranceCompanyRole(val === ROLES.INSURANCE_COMPANY);
  };

  const onFinishPassword = ({ newPassword }: { newPassword: string }) => {
    if (!currentUser?.id || !newPassword) return;
    if (actions.changePassword) {
      actions.changePassword(newPassword, currentUser.id);
    }
    formPassword.resetFields();
  };

  return (
    <div className="p-6">
      <Typography className="text-xl font-bold mb-4 ">
        {isAdd ? "REGISTRACIJA NOVOG KORISNIKA" : "UREDI KORISNIKA"}
      </Typography>
      <Form
        colon={false}
        {...layout}
        form={form}
        name="basic"
        onFinish={onFinish}
      >
        <Row>
          <Col span={24} md={14} lg={12}>
            <Form.Item
              label="Korisničko ime"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Unesite korisničko ime!",
                },
              ]}
            >
              <Input placeholder="Unesite korisničko ime" />
            </Form.Item>

            <Form.Item
              label="email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Unesite email korisnika!",
                },
                { type: "email" },
              ]}
            >
              <Input type="email" placeholder="Unesite email korisnika" />
            </Form.Item>

            {isAdd && (
              <Form.Item
                label="Lozinka"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Postavite lozinku za korisnika!",
                  },
                  { min: 6 },
                ]}
              >
                <Input
                  type="password"
                  placeholder="Postavite lozinku za korisnika"
                />
              </Form.Item>
            )}

            <Form.Item
              label="Ime i prezime"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Unesite ime i prezime korisnika!",
                },
              ]}
            >
              <Input placeholder="Unesite ime i prezime korisnika" />
            </Form.Item>

            <Form.Item
              label="Broj telefona"
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: "Unesite broj telefona!",
                },
              ]}
            >
              <Input placeholder="Unesite broj telefona" />
            </Form.Item>

            <Form.Item
              label="Rola"
              name="role"
              rules={[
                {
                  required: true,
                  message: "Odaberite odgovarajuću rolu za korisnika!",
                },
              ]}
            >
              <Select
                className={styles.select}
                placeholder="Odaberite odgovarajuću rolu za korisnika"
                options={Object.values(ROLES).map((role) => ({
                  label: role,
                  value: role,
                }))}
                onChange={onRoleChange}
              />
            </Form.Item>

            {isInsuranceCompanyRole && (
              <Form.Item
                label="Organizacija"
                name="organization"
                rules={[
                  {
                    required: true,
                    message:
                      "Odaberite odgovarajuću organizaciju za korisnika!",
                  },
                ]}
              >
                <Select
                  className={styles.select}
                  placeholder="Odaberite odgovarajuću organizaciju za korisnika"
                  options={insurances.map((insurance: any) => ({
                    label: insurance.name,
                    value: insurance.key,
                  }))}
                />
              </Form.Item>
            )}
          </Col>
          <Col span={24} md={10}>
            {isAdd && (
              <Form.Item
                initialValue={false}
                name="notification"
                label=" "
                valuePropName="checked"
                className="mb-0 md:mb-6"
              >
                <Checkbox>Notifikacija za korisnika</Checkbox>
              </Form.Item>
            )}

            <Form.Item name="note" label=" " initialValue={""}>
              <TextArea rows={10} placeholder="Napomena:" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button
            htmlType="submit"
            className="text-sm text-white bg-primary font-medium w-[132px] rounded-sm  shadow-sm mt-3"
          >
            SPREMI
          </Button>
        </Form.Item>
      </Form>

      {!isAdd && (
        <Form
          colon={false}
          {...layout}
          form={formPassword}
          name="formPassword"
          onFinish={onFinishPassword}
        >
          <Col span={24} md={14} lg={12}>
            <div className="mt-28">
              <Form.Item
                className="mb-0 sm:mb-4"
                label="Nova lozinka"
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: "Unesite novu lozinku!",
                  },
                  { min: 6 },
                ]}
              >
                <Input.Password
                  type="password"
                  placeholder="Unesite novu lozinku"
                />
              </Form.Item>

              <Form.Item label=" ">
                <Button
                  htmlType="submit"
                  className="text-sm text-white bg-secondary font-medium  rounded-sm mt-0"
                >
                  PROMIJENI LOZINKU
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Form>
      )}
    </div>
  );
};

export default AddEditForm;
